import {defineStore} from 'pinia';


export const useKitchenStore = defineStore('kitchen', {

    state : () => ({
        kitchens: [],
        showKitchenCreateModal: null,
        selectedKitchen: { places: [] },
        selectedPlaces: [],
        selectedDish: null
    }),
    getters: {

    },
    actions : {
        addKitchen(kitchen){
        const ids =  this.kitchens.map(k => k.id);

         if(ids.includes(kitchen.id)){
          this.kitchens =  this.kitchens.map(k => {
                if(k.id == kitchen.id){
                    return kitchen;
                }
                return k;
            })
         }else{
            this.kitchens.push(kitchen);
         }
           
        },
        setKitchens(kitchens){
            this.kitchens = kitchens;
        },
        toggleKitchenCreateModal(){
            this.showKitchenCreateModal = !this.showKitchenCreateModal;
        },
        changeKitchen(kitchen){
            this.selectedKitchen = kitchen;
        },
        changeSelectedPlaces(placeIds){
            this.selectedPlaces = placeIds;
        },
        changeDish(dish){
            this.selectedDish = dish;
        },

        addDishToKitchen(dish){

          this.kitchens =  this.kitchens.map(k => {

                if(dish.kitchenId == k.id){

                    const dishIds = k.dishes.map(d => d.id);

                    if(dishIds.includes(dish.id)){
                       k.dishes = k.dishes.map(d => {
                         if(d.id == dish.id){
                            return dish;
                         }
                         return d;
                       })

                       
                    }else{
                        k.dishes.push(dish);

                    }
                    return k;
                }

                return k;

            });
            
        },

        removeDish(id){

            this.kitchens = this.kitchens.map((k) => {
               const dishes =  k.dishes.filter(d => d.id != id );
               k.dishes = dishes;
               return k;
            })

        }
    }
})